import api, { setHeaderToken, removeHeaderToken } from "../../../apis/Api";
import config from "../../../config";

import router from "@/router";
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    ticketList: {},
    ticketDetail: {}
  },
  getters: {
    getTicketList(state) {
      return state.ticketList;
    },
    getTicketDetail(state) {
      return state.ticketDetail;
    }
  },
  mutations: {
    setTicketList(state, payload) {
      state.ticketList = payload;
    },
    setTicketDetail(state, payload) {
      state.ticketDetail = payload;
    }
  },
  actions: {
    createTicket({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    getTicketList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setTicketList", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getTicketDetail({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setTicketDetail", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession()
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    upload({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          baseURL: config("api.baseUrl_storage"),
          method: "post",
          url: "storage/image/set",
          data: payload,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data"
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    download({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_storage"),
        method: "get",
        url: "/image/get/" + payload,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          console.log(response);
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", payload);
          document.body.appendChild(fileLink);

          fileLink.click();
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    preview({ dispatch }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_storage"),
        method: "get",
        url: "/image/get/" + payload,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response]));

          let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=800,height=500,left=100,top=100`;
          window.open(fileURL, 'pdfPopup', params);

          popupWindow.onload = () => {
            popupWindow.close();
            dispatch("setLoading", false);
          };
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    example({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_storage"),
        method: "get",
        url: "/id/" + payload,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          console.log(response);
          var fileURL = window.URL.createObjectURL(new Blob([response]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", payload);
          document.body.appendChild(fileLink);

          fileLink.click();
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    setLoading({ commit }, payload) {
      commit("loader/setLoading", payload, {
        root: true
      });
    }
  }
};
